import loadIn from "./components/loadIn";
import cursor from "./components/cursor";
import heroSlider from "./components/hero-slider";
import header from "./components/header";
import testimonial from "./components/testimonial-slider";
import gallery from "./components/gallery-slider";
import infiniteScroll from "./components/infinite-scroll";
import footer from "./components/footer"
import lazyLoad from "./components/lazy-load";
import notice from "./components/notice";
import websiteNotice from "./components/website-notice";

document.addEventListener("DOMContentLoaded", () => {
    cursor();
    heroSlider();
    header();
    testimonial();
    gallery();
    infiniteScroll();
    footer();
    loadIn();
    lazyLoad();
    notice();
    // websiteNotice();
});
